import TripCardAcceleratedCheckinContainer from './TripCardAcceleratedCheckinContainer';

export default TripCardAcceleratedCheckinContainer;
